import { styleMap } from 'lit/directives/style-map.js'
import { property } from 'lit/decorators.js'
import { html } from 'lit'

import { LfuiElement } from '#utils/element'

import styles, { locals } from './lfds-spinner.css.ts'

/**
 * @name LfdsSpinner
 *
 * @status ready
 * @tag lfds-spinner
 */
export default class LfdsSpinner extends LfuiElement {
	static styles = styles

	@property({ type: Number }) size: 20 | 24 | 32 | 40 | 48 | 64 = 32

	@property() color?: string

	render() {
		return html`
			<span
				class="spinner ${this.color ? 'monochrome' : ''} ${this.size < 32
					? 'small'
					: ''}"
				aria-label="Laddar"
				role="progressbar"
				style="${styleMap({
					[locals.internal_size]: String(this.size),
					[locals.single_color]: this.color
				})}"
			>
			</span>
		`
	}
}
